var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _gql;
import { GraphQLWrapper } from '@aragon/connect-thegraph';
import * as queries from './queries';
import { parseAgreement, parseSigner, parseSignatures, parseCurrentVersion, parseVersions, parseVersion, parseDisputableApps, parseCollateralRequirement, parseAction, parseStaking, parseStakingMovements, parseERC20, } from './parsers';
export function subgraphUrlFromChainId(chainId) {
    if (chainId === 1) {
        return 'https://api.thegraph.com/subgraphs/name/aragon/aragon-agreement-mainnet';
    }
    if (chainId === 4) {
        return 'https://api.thegraph.com/subgraphs/name/aragon/aragon-agreement-rinkeby';
    }
    if (chainId === 100) {
        return 'https://api.thegraph.com/subgraphs/name/aragon/aragon-agreement-xdai';
    }
    return null;
}
export default class AgreementConnectorTheGraph {
    constructor(config) {
        _gql.set(this, void 0);
        if (!config.subgraphUrl) {
            throw new Error('AgreementConnectorTheGraph requires subgraphUrl to be passed.');
        }
        __classPrivateFieldSet(this, _gql, new GraphQLWrapper(config.subgraphUrl, {
            pollInterval: config.pollInterval,
            verbose: config.verbose,
        }));
    }
    async disconnect() {
        __classPrivateFieldGet(this, _gql).close();
    }
    async agreement(agreement) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_AGREEMENT('query'), { agreement }, (result) => parseAgreement(result));
    }
    onAgreement(agreement, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_AGREEMENT('subscription'), { agreement }, callback, (result) => parseAgreement(result));
    }
    async currentVersion(agreement) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_CURRENT_VERSION('query'), { agreement }, (result) => parseCurrentVersion(result, this));
    }
    onCurrentVersion(agreement, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_CURRENT_VERSION('subscription'), { agreement }, callback, (result) => parseCurrentVersion(result, this));
    }
    async version(versionId) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_VERSION('query'), { versionId }, (result) => parseVersion(result, this));
    }
    onVersion(versionId, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_VERSION('subscription'), { versionId }, callback, (result) => parseVersion(result, this));
    }
    async versions(agreement, first, skip) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ALL_VERSIONS('query'), { agreement, first, skip }, (result) => parseVersions(result, this));
    }
    onVersions(agreement, first, skip, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ALL_VERSIONS('subscription'), { agreement, first, skip }, callback, (result) => parseVersions(result, this));
    }
    async disputableApps(agreement, first, skip) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ALL_DISPUTABLE_APPS('query'), { agreement, first, skip }, (result) => parseDisputableApps(result, this));
    }
    onDisputableApps(agreement, first, skip, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ALL_DISPUTABLE_APPS('subscription'), { agreement, first, skip }, callback, (result) => parseDisputableApps(result, this));
    }
    async signer(signerId) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_SIGNER('query'), { signerId }, (result) => parseSigner(result, this));
    }
    onSigner(signerId, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_SIGNER('query'), { signerId }, callback, (result) => parseSigner(result, this));
    }
    async signatures(signerId, first, skip) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_SIGNATURES('query'), { signerId, first, skip }, (result) => parseSignatures(result, this));
    }
    onSignatures(signerId, first, skip, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_SIGNATURES('query'), { signerId, first, skip }, callback, (result) => parseSignatures(result, this));
    }
    async collateralRequirement(collateralRequirementId) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_COLLATERAL_REQUIREMENT('query'), { collateralRequirementId }, (result) => parseCollateralRequirement(result, this));
    }
    onCollateralRequirement(collateralRequirementId, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_COLLATERAL_REQUIREMENT('subscription'), { collateralRequirementId }, callback, (result) => parseCollateralRequirement(result, this));
    }
    async staking(stakingId) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_STAKING('query'), { stakingId }, (result) => parseStaking(result, this));
    }
    onStaking(stakingId, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_STAKING('query'), { stakingId }, callback, (result) => parseStaking(result, this));
    }
    async stakingMovements(stakingId, agreementId, first, skip) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_STAKING_MOVEMENTS('query'), { stakingId, agreementId, first, skip }, (result) => parseStakingMovements(result, this));
    }
    onStakingMovements(stakingId, agreementId, first, skip, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_STAKING_MOVEMENTS('query'), { stakingId, agreementId, first, skip }, callback, (result) => parseStakingMovements(result, this));
    }
    async action(actionId) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_ACTION('query'), { actionId }, (result) => parseAction(result, this));
    }
    onAction(actionId, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_ACTION('query'), { actionId }, callback, (result) => parseAction(result, this));
    }
    async ERC20(tokenAddress) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GET_ERC20('query'), { tokenAddress }, (result) => parseERC20(result));
    }
    onERC20(tokenAddress, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GET_ERC20('subscription'), { tokenAddress }, callback, (result) => parseERC20(result));
    }
}
_gql = new WeakMap();
//# sourceMappingURL=connector.js.map